import nexo from "@tiendanube/nexo";

// Singleton Nexo client — matches the Storydots template's pattern.
// `clientId` is the TiendaNube App ID configured in the Partner Portal.
// Set `VITE_CLIENT_ID` in `.env` (NOT prefixed with TN_; Storydots-standard).
const instance = nexo.create({
  clientId: import.meta.env.VITE_CLIENT_ID,
  log: import.meta.env.DEV
});

export default instance;
